import * as types from '../mutations'
import APP from '../../constants'

export default {
  /**
   * Incarca licitatiile
   *
   */
  loadAuctions({commit, state}, payload) {
    var that = this;
    if(!payload) return;
    return new Promise((resolve, reject) => {
      axios.get('/api/auctions', {
        params: {
          benefit: payload.benefit,
          type: payload.type,
          paginationOption: payload.paginate,
          page: payload.page,
          filters: payload.filters,
          locale: window.AG.locale,
          user_email: payload.user_email,
          showByDomain: payload.showByDomain
        }
      }).then(response => {
        if (!response.data.message) {
          commit(types.AUCTION_SET_AUCTIONS, response.data.auctions);
          resolve(response.data);
        }else{
          commit(types.AUCTION_SET_AUCTIONS, null);
        }

      }, error => {
        reject(error);
      })
    })
  },

  /**
   * Sterge filtrele pentru licitatii
   *
   */
  clearAuctionsFilters({commit, state}, payload) {
    var that = this;
    if(!payload) return;
    return new Promise((resolve, reject) => {
      axios.get('/api/auctions/clear', {
        params: {
          type: payload.type,
        }
      }).then(response => {
        resolve(response.data);
      }, error => {
        reject(error);
      })
    })
  },

  /**
   * Incarca licitatia
   *
   */
  loadAuction({commit, state}, payload) {
    if(state.Auction.lots.length) return;
    if(window.AG.auction.id == undefined) return;
    var that = this;
    if(!payload) payload = {};
    return new Promise((resolve, reject) => {

      axios.get('/api/lots', {
        params: {
          id: window.AG.auction.id,
          payload: payload,
          locale: window.AG.locale
        }
      }).then(response => {
        commit(types.AUCTION_SET_LOTS, response.data);
        resolve(response.data);
      }, error => {
        reject(error);
      })
    })
  },

  /**
   * Incarca un lot
   *
   */
  loadLot({commit, state}, payload) {
    return new Promise((resolve, reject) => {
     if(state.Auction.lots.length == 0) { // cold lot view
       axios.get('/api/lots', {
         params: {
           id: window.AG.auction.id,
           payload: payload,
           locale: window.AG.locale
         }
       }).then(response => {
         commit(types.AUCTION_SET_LOTS, response.data);
         var result = state.Auction.lots.find(lot => lot.slug === payload.slug);
         resolve(result);
       }, error => {
         reject(error);
       })
     } else {
       var result = state.Auction.lots.find(lot => lot.slug === payload.slug);
       resolve(result);
     }
    })
  },

  /**
   * Incarca un singur lot
   *
   */
  loadSingleLot({commit, state}, payload) {
      var that = this;
      return new Promise((resolve, reject) => {
              axios.get('/api/lot', {
                  params: {
                      id: window.AG.auction.id,
                      slug: payload.slug,
                      locale: window.AG.locale
                  }
              }).then(response => {
                  commit(types.AUCTION_SET_LOTS, response.data.auction);
                  resolve(response.data);
              }, error => {
                  reject(error);
              })
          }
      )
  }
}
